import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash'
import { FormattedMessage } from 'react-intl';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import FormHelperText from '@mui/material/FormHelperText';

import { sub } from 'date-fns';
import { zhTW } from "date-fns/locale";

import { rangeShortcuts, updateDateRangeByShortcut } from './data/dateRangeConstants';

import theme from '../../theme';

import useColorSystem from '../../hook/useColorSystem';
import useGlobalStatus from '../../hook/useGlobalStatus';

import { DateRangeOutlinedIcon, SettingsOutlinedIcon } from '../../constants/images';


const DateRangeEdit = ({ dateRange, setDateRange, inputErrorMsg }) => {
  const { currentActiveData, locale, entryPath, modalContent, modalData, setModalData } = useGlobalStatus();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { colorMedia, mainColor, lightColor, darkColor, w01Color } = useColorSystem();

  const handleShortcutDateRange = (newDateRange) => {
    setDateRange(newDateRange);
  }

  const handleDateRangeFromCalendar = (target, value) => {
    setDateRange(prev => ({
      ...prev,
      [target]: value
    }))
  }

  return (
    <Box>
      <Box>
        <Typography
          sx={{
            ...theme.typography.h4_normal,
            mb: 2,
            color: theme.palette.grey.w700,
            display: "flex",
            alignItems: 'center'
          }}
        >
          <DateRangeOutlinedIcon
            sx={{
              mr: 0.5,
              verticalAlign: 'sub'
            }}
          />
          <FormattedMessage id="createData.modal.download.date" />
        </Typography>
      </Box>

      <Box
        sx={{
          margin: "16px 0px 16px",
          display: "flex",
          justfyContent: "start",
          wudth: '100%'
        }} >
        <ButtonGroup
          variant="text"
          aria-label="text button group"
          color={colorMedia}
        >
          {rangeShortcuts.map((el) => (
            <Button
              key={el.range}
              onClick={() => {
                const newDateRange = updateDateRangeByShortcut(el.range);
                if (newDateRange) {
                  handleShortcutDateRange(newDateRange);
                }
              }}
            >
              <FormattedMessage id={el.id} />
            </Button>
          ))}
        </ButtonGroup>
      </Box>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center'
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={locale.includes("en") ? null : zhTW}>
          <DatePicker
            value={dateRange.startReportDate}
            inputFormat="yyyy/MM/dd"
            views={['year', 'month', 'day']}
            maxDate={sub(new Date(), { days: 1 })}
            onChange={(value) => {
              handleDateRangeFromCalendar('startReportDate', value)
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  sx={{
                    width: '50%',
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: mainColor,
                      }
                    }
                  }}
                />
              )
            }}
          />
          <Typography ml={1} mr={1}> - </Typography>
          <DatePicker
            value={dateRange.endReportDate}
            inputFormat="yyyy/MM/dd"
            views={['year', 'month', 'day']}
            maxDate={sub(new Date(), { days: 1 })}
            onChange={(value) => {
              handleDateRangeFromCalendar('endReportDate', value)
            }}
            renderInput={(params) => {
              return (
                <TextField
                  {...params}
                  sx={{
                    width: '50%',
                    '& .MuiOutlinedInput-root': {
                      '&.Mui-focused fieldset': {
                        borderColor: mainColor,
                      }
                    }
                  }}
                />
              )
            }}
          />
        </LocalizationProvider>
      </Box>

      <FormHelperText error sx={{ fontSize: 14 }}>
        {inputErrorMsg?.reportDateRange &&
          <FormattedMessage id={inputErrorMsg.reportDateRange} />
        }
      </FormHelperText>
    </Box>
  )
}

export default DateRangeEdit;